import { Link, Outlet } from 'react-router-dom'
import { Layers, ArrowLeft } from 'lucide-react'

export function PlatformAdminLayout() {
  return (
    <div className="min-h-screen bg-gray-50">
      <header className="flex h-16 items-center justify-between border-b border-gray-200 bg-white px-6">
        <div className="flex items-center gap-2">
          <Layers className="h-6 w-6 text-violet-600" />
          <span className="text-lg font-bold text-gray-900">Brix</span>
          <span className="ml-2 rounded-full bg-violet-100 px-2.5 py-0.5 text-xs font-semibold text-violet-700">
            Platform Admin
          </span>
        </div>
        <Link to="/" className="flex items-center gap-1.5 text-sm font-medium text-gray-600 hover:text-gray-900">
          <ArrowLeft className="h-4 w-4" />
          Back to dashboard
        </Link>
      </header>
      <main className="mx-auto max-w-6xl px-6 py-8">
        <Outlet />
      </main>
    </div>
  )
}
